import { useState } from 'react'
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Naviagtion from "./components/Naviagtion";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Chat from "./pages/Chat";
import { AppContext, socket } from './context/appContext'

function App() {
    const [rooms, setRooms] = useState([])
    const [currentRoom, setCurrentRoom] = useState([])
    const [members, setMembers] = useState([])
    const [messages, setMessages] = useState([])
    const [newMessages, setNewMessages] = useState({})
    const [privateMemberMessage, setPrivateMemberMessage] = useState({})
    return (
        <AppContext.Provider value={{ socket, currentRoom, setCurrentRoom, rooms, setRooms, members, setMembers, messages, setMessages, newMessages, setNewMessages, privateMemberMessage, setPrivateMemberMessage }} >
        <BrowserRouter>
            <Naviagtion />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/chat" element={<Chat />} />
            </Routes>
        </BrowserRouter>
        </AppContext.Provider>
    );
}

export default App;
